import { createContext, useState, useContext, PropsWithChildren } from 'react'
import { CreateThreadModal } from './CreateThreadModal'

export type SearchScope = 'contact'|'public'

export interface CreateThreadContextProps {
    openCreateThread: (searchScope?: SearchScope) => void
    closeCreateThread: () => void
}

export const CreateThreadContext = createContext<CreateThreadContextProps>({
    openCreateThread: (searchScope?: SearchScope) => {
        //
    },
    closeCreateThread: () => {
        //
    }
})

export const CreateThreadContextProvider: React.FC<PropsWithChildren> = ({
    children
}) => {

    const [visible, setVisible] = useState(false)
    const [searchScope, setSearchScope] = useState<SearchScope>('contact')

    const openCreateThread = (searchScope: SearchScope = 'contact') => {
        if (searchScope === 'contact' || searchScope === 'public') {
            setSearchScope(searchScope)
        }
        setVisible(true)
    }

    const closeCreateThread = () => {
        setVisible(false)
    }

    return (
        <CreateThreadContext.Provider value={{ openCreateThread, closeCreateThread }}>
            {children}
            <CreateThreadModal
                visible={visible}
                searchScope={searchScope}
                onClose={() => setVisible(false)}
            />
        </CreateThreadContext.Provider>
    )
}

export const CreateThreadConsumer = CreateThreadContext.Consumer

export const useCreateThread= () => {
    return useContext(CreateThreadContext)
}
